<ng-template #headerActions>
  <calcite-button slot="header-actions-end" appearance="transparent" kind="danger" icon-start="trash"
                  (click)="confirmDiscard()">Discard
  </calcite-button>
  <calcite-button slot="header-actions-end" appearance="transparent" icon-start="download" [loading]="downloading()"
                  [disabled]="downloading()" (click)="downloadPresentation()">Download
  </calcite-button>
</ng-template>

<calcite-alert
  [open]="!!loadError()"
  kind="danger"
  label="Error"
  icon
  (calciteAlertClose)="loadError.set(null)"
>
  <div slot="title">Error</div>
  <div slot="message">{{ loadError() }}</div>
</calcite-alert>

<calcite-alert [open]="downloading()" kind="info" label="Generating slides" icon>
  <div slot="title">Generating slides!</div>
  <div slot="message">This may take a minute...</div>
</calcite-alert>

<calcite-alert [open]="loading() && activeTab() === 'subject-location'" kind="info" label="Generating map" icon>
  <div slot="title">Generating aerial map!</div>
  <div slot="message">This may take a moment...</div>
</calcite-alert>

@let tabIndex = activeTabIndex();

<calcite-shell>
  <calcite-shell-panel slot="panel-start" width="m">
    <calcite-action-bar layout="vertical" expand-disabled>
      @for (tab of tabs; track tab.id; let i = $index) {
        <calcite-action
          [text]="tab.label"
          text-enabled
          scale="l"
          class="vs-tab-action"
          [class.active]="i === tabIndex"
          [icon]="tab.icon"
          [active]="i === tabIndex"
          [disabled]="loading() || i > firstIncompleteIndex()"
          (click)="selectTab(tab.id)"
        />
      }
    </calcite-action-bar>
  </calcite-shell-panel>

  <div class="app-flex-row app-align-right app-padded-2" slot="panel-bottom">
    <calcite-button
      icon-start="caret-left"
      appearance="outline"
      kind="neutral"
      alignment="end"
      slot="actions-end"
      [disabled]="tabIndex === 0"
      (click)="selectTabIndex(tabIndex - 1)"
    >Back
    </calcite-button>
    <calcite-button
      icon-end="caret-right"
      appearance="solid"
      kind="brand"
      slot="actions-end"
      [disabled]="loading() || tabIndex === tabs.length - 1 || !tabValid()"
      (click)="selectTabIndex(tabIndex + 1)"
    >Next
    </calcite-button>
  </div>

  <calcite-panel class="vs-tab-panel" [loading]="loading()">
    @if (tabTemplates(); as tts) {
      @for (tt of tts; track tt[1]) {
        @if (tt[0]; as tmpl) {
          <calcite-action-bar [slot]="tt[1]" expand-disabled expanded layout="horizontal">
            <ng-container [ngTemplateOutlet]="tmpl"/>
          </calcite-action-bar>
        }
      }
    }
    <router-outlet (activate)="onActivateTab($event)"/>
  </calcite-panel>
</calcite-shell>
